(function () {
var print = (function () {
  'use strict';

  var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

  var register = function (editor) {
    editor.addCommand('mcePrint', function () {
      editor.getWin().print();
    });
  };
  var $_6795qpjljk26xkek = { register: register };

  var register$1 = function (editor) {
    editor.addButton('print', {
      title: 'Print',
      cmd: 'mcePrint'
    });
    editor.addMenuItem('print', {
      text: 'Print',
      cmd: 'mcePrint',
      icon: 'print'
    });
  };
  var $_b2j1tkjmjk26xkel = { register: register$1 };

  global.add('print', function (editor) {
    $_6795qpjljk26xkek.register(editor);
    $_b2j1tkjmjk26xkel.register(editor);
    editor.addShortcut('Meta+P', '', 'mcePrint');
  });
  function Plugin () {
  }

  return Plugin;

}());
})();



// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/print/plugin.js